var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "double-authentication-status",
      class: { "is-active": _vm.active }
    },
    [
      _c(
        "div",
        { staticClass: "double-authentication-status__icon" },
        [
          _vm.active
            ? _c("CompassIcon", { attrs: { icon: "lock" } })
            : _c("CompassIcon", { attrs: { icon: "unlock" } })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "double-authentication-status__text" }, [
        _c(
          "h3",
          {
            staticClass:
              "double-authentication-status__title typographies-heading-h3"
          },
          [_vm._v("\n            " + _vm._s(_vm.getTitle) + "\n        ")]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass:
              "double-authentication-status__label typographies-paragraph-medium-regular"
          },
          [_vm._v("\n            " + _vm._s(_vm.getLabel) + "\n        ")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }